import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const SuiteList = () => {

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.seq.sort = 'asc';
  }
  
  return (
    <EntityList entity="SUITE" augFieldDefs={augFieldDefs} />
  )
}